import { Input } from "./ui/input";
import { Label } from "./ui/label";

const fmtIDR = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");

export const calcDp = (total, value, type) => {
  const raw = type === "persen" ? total * (Number(value) || 0) / 100 : Number(value) || 0;
  const dp = Math.min(Math.max(0, raw), total);
  return { dp, remaining: total - dp };
};

export function DpInput({ total, value, type, onValue, onType, testIdPrefix = "dp" }) {
  const { dp, remaining } = calcDp(total, value, type);
  return (
    <div>
      <Label className="text-xs">DP / Uang Muka</Label>
      <div className="flex gap-2 mt-1">
        <div className="flex border border-neutral-200 rounded-md overflow-hidden">
          <button type="button" onClick={() => onType("rupiah")} data-testid={`${testIdPrefix}-rp`} className={`px-3 text-sm font-semibold ${type === "rupiah" ? "text-white" : "text-neutral-600"}`} style={{ background: type === "rupiah" ? "var(--brand-primary)" : "white" }}>Rp</button>
          <button type="button" onClick={() => onType("persen")} data-testid={`${testIdPrefix}-pct`} className={`px-3 text-sm font-semibold ${type === "persen" ? "text-white" : "text-neutral-600"}`} style={{ background: type === "persen" ? "var(--brand-primary)" : "white" }}>%</button>
        </div>
        <Input data-testid={`${testIdPrefix}-value`} type="number" min="0" value={value} onChange={e => onValue(e.target.value)} className="flex-1" />
      </div>
      <div className="flex justify-between text-[11px] mt-1 uppercase tracking-wider">
        <span className="text-neutral-500">DP = <span className="font-mono-tab text-neutral-900">{fmtIDR(dp)}</span></span>
        <span className="text-neutral-500">Sisa = <span className="font-mono-tab font-bold" style={{ color: "var(--brand-primary)" }} data-testid={`${testIdPrefix}-remaining`}>{fmtIDR(remaining)}</span></span>
      </div>
    </div>
  );
}
